import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

export default function Testimonial() {
  return (
    <section className="py-24 lg:py-32 bg-background" data-testid="testimonial-section">
      <div className="w-full px-5 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="inline-flex h-14 w-14 items-center justify-center rounded-full cmyk-gradient mb-10">
            <Quote size={20} className="text-white" strokeWidth={2.5} />
          </div>

          <h2 className="font-display text-4xl sm:text-5xl lg:text-[4rem] font-semibold text-foreground tracking-tight leading-[1.05]" data-testid="testimonial-title">
            Mais do que fornecedores,<br />
            <span className="cmyk-text">parceiros</span>.
          </h2>

          <div className="mt-12 flex items-center justify-center gap-3 text-sm text-muted-foreground">
            <span className="h-px w-12 bg-border" />
            <span className="font-display tracking-wide uppercase text-xs">Ecoption Supply · Portugal</span>
            <span className="h-px w-12 bg-border" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
